import { TourStep } from "../inputGraphEditor/components/GuidedTour";

export const outputEditorTourSteps: TourStep[] = [
	{
		targetSelector: ".svgDualGraph",
		title: "Floorplan Canvas",
		description:
			"Drag rooms directly on the canvas when no toolbar tool is selected. Once you select any tool below, room dragging is disabled until that tool is turned off.",
		placement: "bottom",
		onEnter: () => {
			let targetEl = document.querySelector(".room-area") as Element;
			if (!targetEl)
				targetEl = document.querySelector(".svgDualGraph") as Element;

			if (targetEl) {
				const rect = targetEl.getBoundingClientRect();
				const cursor = document.createElement("div");
				cursor.id = "tour-fake-cursor";
				cursor.style.position = "fixed";
				cursor.style.left = `${rect.left + rect.width / 2}px`;
				cursor.style.top = `${rect.top + rect.height / 2}px`;
				cursor.style.zIndex = "10005";
				cursor.style.pointerEvents = "none";
				cursor.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.5"><path d="M10.5 4.5C10.5 3.1 11.6 2 12.9 2C14.2 2 15.3 3.1 15.3 4.5V11.9L16.2 11C17.1 10.1 18.6 10.1 19.6 11C20.5 11.9 20.5 13.4 19.6 14.4L13.9 20.1C12.9 21.1 11.5 21.6 10.1 21.6C7.1 21.6 4.8 19.3 4.8 16.3V9.9C4.8 8.5 5.9 7.4 7.2 7.4C8.5 7.4 9.6 8.5 9.6 9.9V11.5L10.5 10.5V4.5Z" fill="#FBE5C6"/></svg>`;
				cursor.classList.add("tour-fake-drag-animation");
				document.body.appendChild(cursor);
			}
		},
		onExit: () => {
			const cursor = document.getElementById("tour-fake-cursor");
			if (cursor) cursor.remove();
		},
	},
	{
		targetSelector: "#output-tool-wall-transformation",
		title: "Wall Transformation",
		description:
			"Expand this to add, select, or delete walls. Note: Selecting any transformation tool automatically locks rooms so they aren't accidentally dragged.",
		placement: "left",
	},
	{
		targetSelector: "#output-tool-lock-rooms",
		title: "Lock Rooms",
		description:
			"You can manually toggle this to lock or unlock room movement. It's helpful once you are done arranging the layout.",
		placement: "left",
	},
	{
		targetSelector: "#output-tool-plot-boundary",
		title: "Plot Boundary",
		description:
			"Toggle the plot boundary. Keep your layout within this allocated area.",
		placement: "left",
	},
	{
		targetSelector: "#output-tool-components",
		title: "Components",
		description:
			"Place doors and windows into walls. Click a component type then click a wall to place it.",
		placement: "left",
	},
	{
		targetSelector: "#output-tool-units",
		title: "Units Switch",
		description:
			"Easily toggle dimensions across the entire editor between Feet and Meters.",
		placement: "left",
	},
	{
		targetSelector: "header",
		title: "Top Navigation",
		description:
			"From the top menu, you can save your floorplan, export it as a JSON or PDF, and change the document name.",
		placement: "bottom",
	},
	{
		targetSelector: "button[title='Back to Input']",
		title: "View Original Graph",
		description:
			"Click this button to see the original input graph that generated this layout.",
		placement: "bottom",
	},
];
